import { createContext, useState } from 'react';

export const SchedulerViewContext = createContext();

export function SchedulerViewProvider({ children }) {
  const [dialogType, setDialogType] = useState("");
  const [selectedChain, setSelectedChain] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [userHoursDiff, setUserHoursDiff] = useState(null);

  return (
    <SchedulerViewContext.Provider
      value={{
        selectedChain,
        setSelectedChain,
        selectedStore,
        setSelectedStore,
        selectedFloor,
        setSelectedFloor,
        dialogType,
        setDialogType,
        userHoursDiff,
        setUserHoursDiff,
      }}
    >
      {children}
    </SchedulerViewContext.Provider>
  );
}
